import { useSelector } from "react-redux"
import { Link, Navigate, Outlet } from "react-router-dom"
import { meSelector } from "../redux/globalSlice"
import { isPrivilegedUser } from "../api/models"
import { MFA_REQUIRED } from "../auth/mfaPolicy"
import Spinner from "./widgets/Spinner"

// Client-side gate for the privileged routes: system admin or any org
// membership, AND MFA enabled on the Cognito account. UX only — real
// enforcement lives in the backend (requirePrivileged in api_auth.ts).
export default function RequirePrivileged() {
  const me = useSelector(meSelector)?.data

  if (me === undefined)
    return (
      <div className="page">
        <Spinner size={24} />
      </div>
    )

  if (!isPrivilegedUser(me))
    return <Navigate to="/" replace />

  if (MFA_REQUIRED && me.mfaEnabled !== true)
    return (
      <div className="page">
        <h1 className="page-title">Two-Factor Authentication Required</h1>
        <p>
          Admin tools are only available after you enable two-factor
          authentication on your account.
        </p>
        <Link to="/account" className="card-link">
          Enable MFA in Account Settings
        </Link>
      </div>
    )

  return <Outlet />
}
